<template>
    <div>
        <div class="item-block" >
            <div class="item-tops" >
                <span class="pice-name">{{ goodsSkuDetail.sku_name }}</span>
            </div>
            <div style="color: #82848a; margin-bottom: 10px;font-size: 11px;">
                <span>已售</span>
                <span>{{ goodsSkuDetail.sale_num }}{{ goodsSkuDetail.unit }}</span>
            </div>
            <div class="goods-label-wrap">
                <goodsLabel :goods="goodsSkuDetail" width="400"></goodsLabel>
                <goodsGroupLabel :goods="goodsSkuDetail"></goodsGroupLabel>
                <goodsCodeLabel :goods="goodsSkuDetail"></goodsCodeLabel>
            </div>
            <div class="discount-banner "
             :style="{backgroundColor:comactiveinfo.bag}"
             v-if="activeinfo.promotion_label"
                >
                <div class="activity-name">
                    <!-- <i class="discount-icon iconfont iconicon_naozhong"></i>         -->
                     <img  style="margin-left:16px;" :src="comactiveinfo.iocn" alt="">
                    <span style="font-size: 20px;" >{{comactiveinfo.titlename}}</span>
                </div>
                <div class="surplus-time" v-if="goodsSkuDetail.promotion_type == 1 && discountTimeMachine.currentTime && addonIsExit.discount">
                    <span>{{ discountText }}</span>
                    <count-down class="count-down" v-on:start_callback="countDownS_cb()"
                        v-on:end_callback="countDownE_cb()" :currentTime="discountTimeMachine.currentTime"
                        :startTime="discountTimeMachine.startTime" :endTime="discountTimeMachine.endTime" :dayTxt="'天'"
                        :hourTxt="'小时'" :minutesTxt="'分钟'" :secondsTxt="'秒'"></count-down>

                    <!-- :tipText="'距离开始文字1'"
                    :tipTextEnd="'距离结束文字1'"
                    :endText="'结束自定义文字2'"-->
                </div>
                
            </div>
            <div class="promotion-price">
         
                <template v-if="activeinfo.promotion_label">
                    <!-- 活动类型价格显示 -->
                    <showPirceInfo :comactiveinfo="comactiveinfo" :token="token" :goodsSkuDetail="goodsSkuDetail">
                    </showPirceInfo>
                </template>
                <template v-else>
                    <!-- 非营销活动类型价格显示 -->
                    <notActivityPirce :goodsSkuDetail="goodsSkuDetail" :token="token"></notActivityPirce>
                </template>
                    <dl class="mdoleDome-goods_attr_format" v-if="goodsSkuDetail.freeshipping&&goodsSkuDetail.freeshipping.length>0">
                <dt class="active-hd">免邮规则</dt>
                <dd><span v-for="(item,index) in goodsSkuDetail.freeshipping" :key="index">
                    {{item.name}}满{{item.price}}包邮;
                </span></dd>
            </dl>
            <dl class="mdoleDome-goods_attr_format" v-if="goodsSkuDetail.goods_limit > 0">
                <dt class="ns-text-color-gray active-hd">限购规则</dt>
                <dd>提示：本商品为限购商品，超过{{ goodsSkuDetail.goods_limit }}{{ goodsSkuDetail.unit }}恢复原价</dd>
            </dl>
            <dl v-if="activeinfo.promotion_info?.price_json&&activeinfo.promotion_info.price_json.length>0">
                    <dt class="active-hd">
                        阶梯规则
                    </dt>
                    <dd>
                        <span v-for="(item,index) in activeinfo.promotion_info.price_json" :key="index">
                        
                            {{item.num}} {{goodsSkuDetail.unit}}起批     
                             <span  style=" color: red;">
                                        <em >¥</em>
                                       <template v-if="token">
                                        {{goodsSkuDetail.sale_control?.view_price? item.price :goodsSkuDetail.sale_control.not_buy_msg}}
                                       </template>
                                       <template v-else>
                                         登录可见
                                       </template>
                           </span >;
                      </span>
                    </dd>
             </dl>
            <dl  v-if="goodsSkuDetail.get_free_goods !== null && goodsSkuDetail.get_free_goods !== undefined && goodsSkuDetail.get_free_goods !== ''">
                <dt class="active-hd">换购规则</dt>
                <dd v-if="goodsSkuDetail.get_free_goods !== null">
                    <div class="getFreeBox">
                        <p>{{ goodsSkuDetail.get_free_goods.goods_range>0?('(可任选'+goodsSkuDetail.get_free_goods.goods_range+'种)'):'(可任选个数，无限制)' }}</p>
                        <div>
                            <template v-for="freeItem in returnFreeInfo">
                                <p v-if="freeItem.title!=''">{{ freeItem.title }}</p>
                                <p>{{ freeItem.text }}</p>
                            </template>
                        </div>
                    </div>
                </dd>
                <dd v-if="goodsSkuDetail.get_free_goods === null || goodsSkuDetail.get_free_goods === undefined || goodsSkuDetail.get_free_goods === ''">无换购商品</dd>
            </dl>
            </div>
        </div>
    </div>
</template>

<script>
import showPirceInfo from "./compontens/showPirceInfo"
import notActivityPirce from './compontens/notActivityPirce.vue';
import CountDown from "vue2-countdown";
import goodsCodeLabel from "@/components/goods-label/goods-code-label.vue";
import goodsGroupLabel from "@/components/goods-label/goods-group-label.vue";
import goodsLabel from "@/components/goods-label/goods-label.vue";
export default {
    components: {
        showPirceInfo,
        notActivityPirce,
		CountDown,
		goodsCodeLabel,
		goodsGroupLabel,
		goodsLabel
	},
    props: {
        goodsSkuDetail: {
            type: Object,
            default: () => { },
        },
        token: {
            type: String,
            default: ''
        },
        goods_member_price: {
            type: Object,
            default: () => { }
        },
        activeinfo: {
            type: Object,
            default: () => { }
        },
        discountTimeMachine:{
            type:Object,
            default:()=>{}
        },
        addonIsExit:{
            type:Object,
            default:()=>{}
        },
        discountText:{
            type:String,
            default:''
        }

    },
    /**
     *   seckill   秒杀
     *   discount  特价
     *   wholesale 阶梯
     */
    computed: {
        // 活动信息数据进行处理
        comactiveinfo() {
            let updatedInfo = {};
            let coupon_price = this.goodsSkuDetail.coupon_price;
            let sub_coupon_price = (coupon_price!=undefined&&coupon_price!=''&&coupon_price!=null&&parseFloat(coupon_price)>0?coupon_price:'');
            switch (this.activeinfo.promotion_label) {
                case 'seckill':
                    
                    updatedInfo = {
                        name: "秒杀价",
                        price: (parseFloat(this.activeinfo.promotion_info.price)>parseFloat(this.activeinfo.promotion_info.seckill_price)?this.activeinfo.promotion_info.price:''),
                        activity_price: this.activeinfo.promotion_info.seckill_price,
                        coupon_price:sub_coupon_price,
                        iocn:require('../../../assets/images/miao.png'),
                        titlename:'秒杀专区',
                        bag:'#F7547B'
                    }
                    break;
                case 'discount':
                    updatedInfo = {
                        name: "特价",
                        price: (parseFloat(this.activeinfo.promotion_info.price)>parseFloat(this.activeinfo.promotion_info.discount_price)?this.activeinfo.promotion_info.price:''),
                        activity_price: this.activeinfo.promotion_info.discount_price,
                        coupon_price:sub_coupon_price,
                        iocn:require('../../../assets/images/te.png'),
                         titlename:'限时特价',
                         bag:'#44B2FC'
                    }
                    break;
                case 'wholesale':
                    updatedInfo = {
                        name: "阶梯价",
                        price: this.goodsSkuDetail.price,
                        activity_price: this.activeinfo.promotion_info.min_price,
                        coupon_price:sub_coupon_price,
                        max_pice:this.activeinfo.promotion_info.max_price,
                        price_json: this.activeinfo.promotion_info.price_json,
                        iocn:require('../../../assets/images/pi.png'),
                         titlename:'阶梯专区',
                          bag:'#F88B57'
                    }
                    break;
            }
            return updatedInfo
        },
        returnFreeInfo() {
            let textArr = [];
            let text_bool = (!this.goodsSkuDetail||!this.goodsSkuDetail.get_free_goods||!this.goodsSkuDetail.get_free_goods.getFreeGoods);
            if(text_bool){
                return textArr;
            }
            let bool = (this.goodsSkuDetail.get_free_goods.is_ladder > 0);
            // 当前主商品的单位
            let main_unit = (this.goodsSkuDetail.unit ? this.goodsSkuDetail.unit : '盒');
            this.goodsSkuDetail.get_free_goods.getFreeGoods.forEach(item => {
                // 是否是本商品
                let ifBenPing = (item.goods_id===this.goodsSkuDetail.goods_id);
                // 副商品单位
                let fu_unit = (item.goods.unit?item.goods.unit:'盒');
                if (bool) {
                    if (typeof item.ladder_json === 'string') {
                        item.ladder_json = JSON.parse(item.ladder_json)
                    }
                    item.ladder_json.forEach((item1, index) => {
                        let limit = (item.limit||item.goods_limit||0);
                        let price = (parseFloat(item1.rangPrice)*parseInt(item1.rang)).toFixed(2);
                        let str = `单次购买本商品${item1.mainRang}${main_unit}+${price}元换购${item1.rang}${fu_unit}${ifBenPing?'本品':item.goods.goods_name}`;
                        if(limit>0){
                            str += `,限购${item.limit}${fu_unit}`;
                        }
                        let textObj = {title:'',text:str};
                        if(ifBenPing){
                            textArr.unshift(textObj);
                        }else{
                            textArr.push(textObj);
                        }
                    });
                } else {
                    let price = (parseFloat(item.price)*parseInt(item.num)).toFixed(2);
                    let str = `单次购买本商品${item.count}${main_unit}+${price}元换购${item.num}${fu_unit}${ifBenPing?'本品':item.goods.goods_name}`;
                    if (item.limit > 0) {
                        str +=`,限购${item.limit}${fu_unit}`;
                    }
                    let textObj = {title:'',text:str}
                    textArr.push(textObj);
                }
            })
            return textArr;
        },
    },
    methods:{
        countDownE_cb(){
            this.$emit('countDownE_cb')
        },
        countDownS_cb(){
            this.$emit('countDownS_cb')
        }
    }
}
</script>

<style lang="scss" scoped>
.promotion-price{
    padding: 20px 0 10px 0;
    background: #F3F3F3;
}

.active-hd{
    display: inline-block;
    min-width: 88px;
    height: 35px;
    line-height: 35px;
    text-align-last : justify !important;
    padding-left: 16px;
    font-size: 14px;
    margin-right: 16px;
    color: #2c2626e0;
    font-weight: 600;
   
}
dd{
    padding-left: 16px;
}
.getFreeBox{
    display: flex;
    flex-direction: column;
    gap: 6px;
    p{
        color: #ff547b;
        line-height: 1rem;
    }
    >div{
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
}
.goods-label-wrap{
    display: flex;
    gap: 6px;
    align-items: center;
    margin-bottom: 10px;
}
</style>